import { onActivated } from "vue"

import { baseQuery } from "@/queries"
import { KirbyQuerySchema } from "@/queries/kql"

import { useKirby } from "./use-kirby"
import { useRoot } from "./use-root"

export const usePage = async <T>() => {
  const root = useRoot()
  const { getPage } = useKirby()

  onActivated(() => (document.title = `${root.$site.title}`))

  const page = await getPage<T>(root.$route.path)
  return page
}

export function getPageQuery(
  pageId: string,
  query?: KirbyQuerySchema["select"],
): KirbyQuerySchema {
  return {
    query: `page("${pageId}")`,
    select: {
      ...baseQuery,
      ...query,
    },
  }
}
